import React from "react";
import { Paper, Text } from "@mantine/core";
import { useAppSelector } from "../../../../app/hooks";
import { DeckBimViewer } from "@multiconsult-group/multiplacer-ui";
import {
  selectAdvancedCopyTargetCeilingGridPixPaths,
  selectAdvancedCopyTargetViewerPixPolygons,
} from "./advancedCopyDevicesSelectors";

export const AdvancedCopyDevicesTargetViewer: React.FC = () => {
  const rotation = useAppSelector((state) => state.design.rotation);
  const polygons = useAppSelector(selectAdvancedCopyTargetViewerPixPolygons);
  const paths = useAppSelector(selectAdvancedCopyTargetCeilingGridPixPaths);

  if (polygons.length === 0) {
    return (
      <Paper
        bg="gray.0"
        radius="md"
        p="md"
        style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Text size="sm" c="dimmed">
          Velg et mÃ¥lrom i tabellen for Ã¥ vise romgeometri
        </Text>
      </Paper>
    );
  }

  return (
    <Paper bg="gray.0" radius="md" p="md" style={{ flex: 1, minHeight: 320 }}>
      <DeckBimViewer flip2dCoordinate={true} angle={rotation} paths={paths} polygons={polygons} />
    </Paper>
  );
};
